define("shared/components/shared/ui/report/share", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="u--p__b">
    <p class="u--text--bold u--text--md">
      {{t "analytics.report.settings.share.header"}}
    </p>
    <div class="o--btnBar u--m__0" data-test-id="ui-report-settings-share">
      <div class="o--btnGroup cRP--btnGroup u--m__0">
        <Shared::Link
          @href={{@report.url}}
          @openInNewTab={{true}}
          @text={{@report.url}}
          class="cRP--btnGroup__input o--form__input o--form__input--view u--m__b__0 u--ellipsis qa--analyticsReport_reportLinkInputField"
          {{track "clicked-performance-report-url" "click" performance_report_url=@report.url}}
        />
        <CopyButton
          @text={{@report.url}}
          class="o--btn o--btn--outline u--m__b__0 u--m__t__0 qa--analyticsReport_copyReportLinkBtn at--performanceReport__copyLinkBtn at--collabsPerformanceReport__copyLinkBtn"
          {{on "click" this.handleCopySuccess}}
          {{track "copied-performance-report-url" "click" performance_report_url=@report.url page=@reportStatus.page}}
        >
          {{t "analytics.report.settings.share.copy_link"}}
        </CopyButton>
      </div>
      <p class="o--form__helpText u--text--sm u--text--light u--text--hair qa--analyticsReport_viewCountField">
        {{t "analytics.report.settings.share.views" updatedTime=@report.formattedUpdatedTimeLowerCase views=@reportViews}}
      </p>
    </div>
    <hr />
  </div>
  */
  {
    "id": "l/nyzC2H",
    "block": "[[[10,0],[14,0,\"u--p__b\"],[12],[1,\"\\n  \"],[10,2],[14,0,\"u--text--bold u--text--md\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"analytics.report.settings.share.header\"],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"o--btnBar u--m__0\"],[14,\"data-test-id\",\"ui-report-settings-share\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--btnGroup cRP--btnGroup u--m__0\"],[12],[1,\"\\n      \"],[8,[39,1],[[24,0,\"cRP--btnGroup__input o--form__input o--form__input--view u--m__b__0 u--ellipsis qa--analyticsReport_reportLinkInputField\"],[4,[38,2],[\"clicked-performance-report-url\",\"click\"],[[\"performance_report_url\"],[[30,1,[\"url\"]]]]]],[[\"@href\",\"@openInNewTab\",\"@text\"],[[30,1,[\"url\"]],true,[30,1,[\"url\"]]]],null],[1,\"\\n      \"],[8,[39,3],[[24,0,\"o--btn o--btn--outline u--m__b__0 u--m__t__0 qa--analyticsReport_copyReportLinkBtn at--performanceReport__copyLinkBtn at--collabsPerformanceReport__copyLinkBtn\"],[4,[38,4],[\"click\",[30,0,[\"handleCopySuccess\"]]],null],[4,[38,2],[\"copied-performance-report-url\",\"click\"],[[\"performance_report_url\",\"page\"],[[30,1,[\"url\"]],[30,2,[\"page\"]]]]]],[[\"@text\"],[[30,1,[\"url\"]]]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,0],[\"analytics.report.settings.share.copy_link\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"o--form__helpText u--text--sm u--text--light u--text--hair qa--analyticsReport_viewCountField\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"analytics.report.settings.share.views\"],[[\"updatedTime\",\"views\"],[[30,1,[\"formattedUpdatedTimeLowerCase\"]],[30,3]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"hr\"],[12],[13],[1,\"\\n\"],[13]],[\"@report\",\"@reportStatus\",\"@reportViews\"],false,[\"t\",\"shared/link\",\"track\",\"copy-button\",\"on\"]]",
    "moduleName": "shared/components/shared/ui/report/share.hbs",
    "isStrictMode": false
  });

  let ShareComponent = (_class = class ShareComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);
    }

    handleCopySuccess() {
      this.alerts.success(this.intl.t('alerts.analytics.report.settings.share.success'), {
        timeout: 5000
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleCopySuccess", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCopySuccess"), _class.prototype)), _class);
  _exports.default = ShareComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ShareComponent);
});